import { jsx } from "react/jsx-runtime";
import { createContext, useMemo } from "react";
import { objectIdentityKey } from "./objectIdentityKey";
function createStyledContext(props) {
  const OGContext = createContext(null);
  const OGProvider = OGContext.Provider;
  const Context = OGContext;
  const Provider = ({
    children,
    ...values
  }) => {
    const value = useMemo(() => values, [objectIdentityKey(values)]);
    return /* @__PURE__ */ jsx(OGProvider, { value, children });
  };
  Context.Provider = Provider;
  Context.props = props;
  Context.context = OGContext;
  return Context;
}
export {
  createStyledContext
};
//# sourceMappingURL=createStyledContext.js.map
